import { transform } from 'lodash-es';

import type { ITreeItem } from '@components/tree/VTree/types';
import type { GetTFunc } from '@modules/i18n/types';
import type { ITranslateManagerForm } from '@modules/translate-manager/types';

export default function filterTranslationsList(
  list: ITreeItem[],
  t: GetTFunc,
  form: ITranslateManagerForm,
  result: ITreeItem[] = [],
): ITreeItem[] {
  const {
    language,
    search,
    onlyEmpty,
  } = form;

  if (!onlyEmpty && !search) {
    return list;
  }

  return transform(
    list,
    (acc, value) => {
      if (value.children) {
        const item = { ...value, children: [] };
        filterTranslationsList(
          value.children as ITreeItem[],
          t,
          form,
          item.children as ITreeItem[],
        );

        if (item.children.length) {
          acc.push(item);
        }
        return true;
      }
      const translation = t(value.path, { lng: language, fallbackLng: language });

      const maybeEmpty = translation !== value.path && search
        ? translation.toLowerCase().includes(search.toLowerCase())
        : false;

      const needToAdd = onlyEmpty ? translation === '' || translation === value.path : maybeEmpty;

      if (needToAdd) {
        acc.push({ ...value });
      }

      return acc;
    },
    result,
  );
}
